import React from 'react';
import styles from './scss/sms.module.scss';
import { assets } from '../../styles/assets/assets';
import WorktualTab from '../../components/custom_components/worktualTab';
import WorktualDropdown from '../../components/custom_components/WroktualDropdown';
import ContentLayout from '../../layout/contentLayout';
import { Link } from 'react-router-dom';

const Sms = () => {

    return (
        <ContentLayout noPaddingBlock={true}>
            <div className='breadcrumbs'>
                <ol>
                    <li>
                        <Link to=''>Campaign Name</Link>
                    </li>
                    <li>
                        Landing Page
                    </li>
                </ol>
            </div>
            <div className={styles.smssec}>
                <div className={styles.mdflefts}>
                    <p>Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed</p>
                    <div className={styles.searchset}>
                        <input type="text" name="" id="" placeholder='Ask to edit' />
                        <img className={styles.searchlt} src={assets.search_icon} alt="search_icon" />
                        <img className={styles.closeic} src={assets.multi_close} alt="multi_close" />
                    </div>
                </div>
                <div className={styles.mdfrights}>
                    <div className={styles.prevsec}>
                        <div className={styles.previewshowsec}>
                            <div className={styles.mobilelayoutviewsec}>
                                <div className={styles.bodywrapper}>
                                    <div className={styles.mobileheader}>
                                        <img className={styles.topbarimg} src={assets.mobile_topbar} alt="topbarimg" />
                                        <img className={styles.camerafront} src={assets.camera_front} alt="camerafront" />
                                    </div>
                                    <div className={styles.mobilemainsec}>
                                        <div className={styles.userinfotop}>
                                            <span className={styles.backicon}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="17" viewBox="0 0 11 17" fill="none">
                                                    <path d="M8.82725 16.626C9.04066 16.8309 9.31226 16.9427 9.63237 16.9427C10.2726 16.9427 10.7867 16.4584 10.7867 15.8436C10.7867 15.5363 10.6509 15.2569 10.4278 15.0427L3.63762 8.67199L10.4278 2.31995C10.6509 2.10573 10.7867 1.817 10.7867 1.51896C10.7867 0.904242 10.2726 0.419922 9.63237 0.419922C9.31226 0.419922 9.04066 0.531688 8.82725 0.736593L1.28046 7.81511C1.00885 8.05727 0.882747 8.35531 0.873047 8.6813C0.873047 9.00728 1.00885 9.2867 1.28046 9.53817L8.82725 16.626Z" fill="#007AFF" />
                                                </svg>
                                            </span>
                                            <div className={styles.contactinfo}>
                                                <span className={styles.avatorcon}>
                                                    <img src={assets.avatarimg} alt='avator_icon' />
                                                </span>
                                                <p>+447441476247</p>
                                            </div>
                                        </div>
                                        <div className={styles.contentsec}>
                                            <div className={styles.msgsec}>
                                                Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.mobilefooter}>
                                        <img src={assets.message_bar} alt="messgagebottom" />
                                        <div className={styles.optionsbtm}>
                                            <span className={styles.optionsopen}></span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className={styles.btnsec}>
                            <button className='cancelbtn'>Cancel</button>
                            <button className='primarybtn'>Publish</button>
                        </div>
                    </div>
                </div>
            </div>
        </ContentLayout>

    )
}

export default Sms
